import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveGetexRegulationParagraphsRequirementsMutationVariables = Types.Exact<{
  input: Types.RemoveGetexRegulationParagraphsRequirementsInput;
}>;


export type RemoveGetexRegulationParagraphsRequirementsMutation = { __typename?: 'Mutation', removeGetexRegulationParagraphsRequirements: { __typename?: 'RemoveGetexRegulationParagraphsRequirementsPayload', getexRegulation?: { __typename?: 'GetexRegulation', id: string } | null } };


export const RemoveGetexRegulationParagraphsRequirementsDocument = gql`
    mutation RemoveGetexRegulationParagraphsRequirements($input: RemoveGetexRegulationParagraphsRequirementsInput!) {
  removeGetexRegulationParagraphsRequirements(input: $input) {
    getexRegulation {
      id
    }
  }
}
    `;
export type RemoveGetexRegulationParagraphsRequirementsMutationFn = Apollo.MutationFunction<RemoveGetexRegulationParagraphsRequirementsMutation, RemoveGetexRegulationParagraphsRequirementsMutationVariables>;

/**
 * __useRemoveGetexRegulationParagraphsRequirementsMutation__
 *
 * To run a mutation, you first call `useRemoveGetexRegulationParagraphsRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGetexRegulationParagraphsRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGetexRegulationParagraphsRequirementsMutation, { data, loading, error }] = useRemoveGetexRegulationParagraphsRequirementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveGetexRegulationParagraphsRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGetexRegulationParagraphsRequirementsMutation, RemoveGetexRegulationParagraphsRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGetexRegulationParagraphsRequirementsMutation, RemoveGetexRegulationParagraphsRequirementsMutationVariables>(RemoveGetexRegulationParagraphsRequirementsDocument, options);
      }
export type RemoveGetexRegulationParagraphsRequirementsMutationHookResult = ReturnType<typeof useRemoveGetexRegulationParagraphsRequirementsMutation>;
export type RemoveGetexRegulationParagraphsRequirementsMutationResult = Apollo.MutationResult<RemoveGetexRegulationParagraphsRequirementsMutation>;
export type RemoveGetexRegulationParagraphsRequirementsMutationOptions = Apollo.BaseMutationOptions<RemoveGetexRegulationParagraphsRequirementsMutation, RemoveGetexRegulationParagraphsRequirementsMutationVariables>;